<!-- =========================================================================================
    File Name: Password.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="px-8 pt-8 register-tabs-container">
                                <div class="vx-card__title mb-4">
                                    <!-- <h4 class="mb-4">Create Account</h4> -->
                                    <!-- <p>Fill the below form to create a new account.</p> -->
                                <h4 class="mb-4"><strong>비밀번호 변경</strong></h4>
                                <p>비밀번호를 변경하세요</p>
                                </div>
                                <vs-tabs>
                                  <vs-tab label="비밀번호">
                                    <vs-input
                                      v-validate="'required|email'"
                                      data-vv-validate-on="blur"
                                      name="email"
                                      type="email"
                                      icon-pack="feather"
                                      icon-no-border
                                      label-placeholder="이메일"
                                      placeholder="이메일"
                                      v-model="email"
                                      class="w-full mt-6"
                                      @blur="emailOutfocus()"/>
                                      <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                    <vs-input
                                      ref="password"
                                      type="password"
                                      data-vv-validate-on="blur"
                                      name="extra_password"
                                      label-placeholder="임시 비밀번호"
                                      placeholder="임시 비밀번호"
                                      v-model="extra_password"
                                      class="w-full mt-6"
                                      @blur="extraPasswordOutfocus()"/>
                                      <span id="extraPassword"/>
                                      <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <vs-input
                                      ref="password"
                                      type="password"
                                      data-vv-validate-on="blur"
                                      v-validate="'required|min:6|max:10'"
                                      name="new_password"
                                      label-placeholder="새 비밀번호"
                                      placeholder="새 비밀번호"
                                      v-model="new_password"
                                      class="w-full mt-6"
                                      @blur="newPasswordOutfocus()"/>
                                      <span id="newPassword"/>
                                      <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <vs-input
                                      type="password"
                                      v-validate="'min:6|max:10|confirmed:password'"
                                      data-vv-validate-on="blur"
                                      data-vv-as="password"
                                      name="confirm_password"
                                      label-placeholder="새 비밀번호 확인"
                                      placeholder="새 비밀번호 확인"
                                      v-model="confirm_password"
                                      class="w-full mt-6"
                                      @blur="passwordMatch()"/>
                                      <span id="same"/>
                                      <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                                    <vs-button class="float-right mt-6" :disabled="!validateForm" @click="changePasswordConfirm()">완료</vs-button>
                                  </vs-tab>
<!--
                                  <vs-tab label="Firebase">
                                    <register-firebase></register-firebase>
                                  </vs-tab>

                                  <vs-tab label="Auth0">
                                    <register-auth0></register-auth0>
                                  </vs-tab> -->
                                </vs-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

// import RegisterFirebase from "./RegisterFirebase.vue"
// import RegisterAuth0 from "./RegisterAuth0.vue"

export default {
  data() {
    return {
      email: '',
      extra_password: '',
      new_password: '',
      confirm_password: '',
      matchNewPassword: false,
      passwordValidate: false
    }
  },
  computed: {
      validateForm() {
        // 인증할때 포함하는 것을 넣는 곳
          return !this.errors.any() && this.matchNewPassword == true && this.passwordValidate == true
      }
  },
  methods: {
    emailOutfocus() {
      // const payload = {
      //   email: this.email
      // }
      // this.$store.dispatch('auth/checkUserEmail', payload)
    },
    validateExtraPassword(character) {
        return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%*#?&]{6,}$/.test(character)
    },
    validatePassword(character) {
        return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/.test(character)
    },
    extraPasswordOutfocus() {
      if (this.validatePassword(this.extra_password) === true) {
        document.getElementById('extraPassword').innerHTML = '비밀번호가 일치합니다.'
        document.getElementById('extraPassword').style.color = 'blue'
        this.passwordValidate = true
      } else {
        document.getElementById('extraPassword').innerHTML = '비밀번호가 일치하지 않습니다.'
        document.getElementById('extraPassword').style.color = 'red'
        this.passwordValidate = false
      }
    },
    newPasswordOutfocus() {
      if (this.validatePassword(this.new_password) === true) {
        document.getElementById('newPassword').innerHTML = '사용이 가능합니다.'
        document.getElementById('newPassword').style.color = 'blue'

      } else {
        document.getElementById('newPassword').innerHTML = '사용이 불가능합니다.'
        document.getElementById('newPassword').style.color = 'red'

      }
    },
    passwordMatch() {
      // 새 비번과 새 비번 일치 확인
      if(!this.new_password && !this.validatePassword(this.new_password)){
        this.matchNewPassword = false
      }
      if (this.new_password == this.confirm_password) {
        document.getElementById('same').innerHTML='비밀번호가 일치합니다.'
        document.getElementById('same').style.color='blue'
        this.matchNewPassword = true
      }
      else {
        document.getElementById('same').innerHTML='비밀번호가 일치하지 않습니다.'
        document.getElementById('same').style.color='red'
        this.matchNewPassword = false
      }
    },
    changePasswordConfirm() {
      const payload = {
        email: this.email,
        password: this.extra_password,
        newPassword: this.new_password
      }
     // changePassword랑 레스트풀 교체
      this.$store.dispatch('auth/changePassword', payload).then((resolve) => {
        this.$vs.notify({
         color: 'success',
         title: '완료',
         text: '비밀번호가 변경되었습니다.'
       })
       //TODO: 권한 설정 변경 필요.
       this.$acl.change('editor')
       if(resolve.data.first == true){
         this.$router.push('/pages/space/create')
       }else {
         this.$router.push('/apps/space')
       }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '이메일 및 비밀번호를 다시 확인해주십시오.'
        })
      })

    }
  }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;
  // font-family: sans-serif;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
